// Implements: F-VER-004
/**
 * Hand a downloaded file to the browser to save it.
 *
 * An object URL, a link that is clicked and removed again, and the URL revoked
 * on the next turn of the loop: revoking in the same turn can cancel the save
 * in some browsers, and never revoking keeps the whole file in memory.
 */

export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.append(link);
  link.click();
  link.remove();
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);
}
